var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'text-dark': !_vm.nightMode, 'text-light': _vm.nightMode },attrs:{"id":"app"}},[_c('Navbar',{attrs:{"nightMode":_vm.nightMode},on:{"scroll":_vm.scrollTo,"nightMode":_vm.switchMode}}),_c('router-view',{attrs:{"nightMode":_vm.nightMode}}),_c('Footer',{attrs:{"nightMode":_vm.nightMode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }